<div class="card-viewer-container">
  <div class="credit-card" [class.is-loading]="loading">

    <!-- Loading Overlay -->
    <div class="card-loading-overlay" *ngIf="loading">
      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      <span>Loading...</span>
    </div>

    <!-- Top Row: Brand Only (User removed chip) -->
    <div class="card-header">
      <div class="card-brand">
        <span class="patientgo-logo">PatientGo</span>
        <div class="prepaid-badge">PREPAID</div>
      </div>
    </div>

    <!-- Middle Section: Card Number -->
    <div class="card-body">
      <div class="field-group pan-group">
        <label>Card Number</label>
        <div id="cardNumber"></div>
      </div>
    </div>

    <!-- Bottom Section: Info and Networks -->
    <div class="card-footer">
      <div class="info-group">
        <!-- Expiry -->
        <div class="field-group bottom-label">
          <div id="expirationDate"></div>
          <label>Expires</label>
        </div>

        <!-- CVV -->
        <div class="field-group bottom-label">
          <div id="cvv"></div>
          <label>CVV</label>
        </div>
      </div>

      <!-- Network Icons -->
      <div class="network-group">
        <div class="visa-logo">
          <span class="visa-text">VISA</span>
        </div>
      </div>
    </div>
  </div>
</div>